import moment from 'moment';
import { dspxDiffDays } from '../../../../../helpers/dspx-utils';

export const getPlaceholderData = (fromDate, toDate) => {
  const diff = dspxDiffDays(toDate, fromDate);

  const days = [];

  for (let i = 0; i <= diff; i++) {
    const day = {
      name: moment(fromDate).add(i, 'days').format('DD-MM-YYYY'),
      value: Math.floor(Math.random() * 100),
    };

    days.push(day);
  }

  return days;
};
